<template>
  <li class="listitem">
    <div class="bild" v-if="listItem.image">
      <div class="background16-9">
        <div class="positioning">
          <Image
            :imageUrl="listItem.image"
            :smallWidth="515"
            :mediumWidth="240"
            :largeWidth="240"
            :altText="''"
          ></Image>
        </div>
      </div>
    </div>
    <div>
      <a :href="listItem.url">
        <SistaOrdet :text="listItem.title"></SistaOrdet>
      </a>
      <div class="datum d-flex align-items-center">
        <Icon :type="'clock-o'"></Icon>
        <span aria-hidden="true">{{ listItem.publishedDate }}</span>
        <span class="visually-hidden"
          >{{ $texts.publicerad }}: {{ listItem.publishedDate }}</span
        >
      </div>
      <p v-if="truncatedSummary">{{ truncatedSummary }}</p>
    </div>
  </li>
</template>

<script>
import Image from "common/js/vue/image/image.vue";
import Icon from "common/js/vue/image/icon.vue";
import SistaOrdet from "common/js/vue/helpers/sistaordet.vue";

export default {
  name: "ListItem",
  props: {
    listItem: Object,
  },
  data: function () {
    return {
      truncatedSummary: "",
    };
  },
  components: {
    Image,
    Icon,
    SistaOrdet,
  },
  created() {
    this.truncateSummary();
  },
  methods: {
    truncateSummary() {
      if (this.listItem.summary && this.listItem.summary.length > 120) {
        this.truncatedSummary = this.listItem.summary.substring(0, 119) + "...";
      } else {
        this.truncatedSummary = this.listItem.summary;
      }
    },
  },
  watch: {
    listItem: {
      deep: true,
      handler() {
        this.truncateSummary();
      },
    },
  },
};
</script>
